/* DREAMY COMIC — 商品ページ（カルーセル・プラン価格・その場でキャラ作成）と、注文後の未来フォームの動き */
(function () {
  var root = document.querySelector('.dc');
  if (!root) return;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };

  // ---- 段階ごとの人数を数える（数だけ。1回の訪問で同じ段階は1回まで） ----
  var apiEl = document.querySelector('[data-api]');
  var API = apiEl ? apiEl.getAttribute('data-api').replace(/\/generate$/, '').replace(/\/$/, '') : '';
  function track(name) {
    if (!API) return;
    try { if (sessionStorage.getItem('dcev:' + name)) return; sessionStorage.setItem('dcev:' + name, '1'); } catch (e) {}
    try {
      var body = JSON.stringify({ e: name });
      if (navigator.sendBeacon) navigator.sendBeacon(API + '/ev', new Blob([body], { type: 'text/plain' }));
      else fetch(API + '/ev', { method: 'POST', body: body, keepalive: true });
    } catch (e) {}
  }
  function onSeen(el, fn) {
    if (!el || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.isIntersecting) { fn(); io.disconnect(); } }); }, { threshold: 0.2 });
    io.observe(el);
  }
  onSeen(document.getElementById('dc-step-plan'), function () { track('order_seen'); });
  if (document.getElementById('dc-mirai')) track('mirai_open');

  // ---- 「無料で作ってみる」：写真の欄へ移動。スマホは、写真の欄に来るまで画面下にボタンを出す ----
  var stepPhoto = document.getElementById('dc-step-photo');
  Array.prototype.slice.call(document.querySelectorAll('[data-try]')).forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!stepPhoto) return;
      e.preventDefault(); track('try_click');
      stepPhoto.scrollIntoView({ behavior: 'smooth', block: 'start' });
      stepPhoto.classList.add('pulse'); setTimeout(function () { stepPhoto.classList.remove('pulse'); }, 1600);
    });
  });
  var bar = document.getElementById('dc-trybar'), topCta = document.querySelector('.trycta');
  if (bar && stepPhoto && 'IntersectionObserver' in window) {
    var ctaVisible = true, reached = false;
    function syncBar() { bar.hidden = !(window.matchMedia('(max-width: 900px)').matches && !ctaVisible && !reached); }
    if (topCta) new IntersectionObserver(function (es) { ctaVisible = es[0].isIntersecting; syncBar(); }).observe(topCta);
    new IntersectionObserver(function (es) { reached = es[0].isIntersecting || es[0].boundingClientRect.top < 0; syncBar(); }).observe(stepPhoto);
    window.addEventListener('resize', syncBar);
  }

  // ---- カルーセル ----
  var slides = $$('.slide'), thumbs = $$('.thumbs button'), cap = $('#dc-caption'), cur = 0;
  function show(i) {
    if (!slides.length) return;
    cur = (i + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.hidden = k !== cur; });
    thumbs.forEach(function (t, k) { t.setAttribute('aria-pressed', k === cur); });
    if (cap) cap.textContent = slides[cur].getAttribute('data-caption') || '';
  }
  thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
  var prev = $('.nav.prev'), next = $('.nav.next');
  if (prev) prev.addEventListener('click', function () { show(cur - 1); });
  if (next) next.addEventListener('click', function () { show(cur + 1); });
  show(0);

  // ---- プラン（バリエーション）→ 価格表示 ----
  var priceEl = $('#dc-price'), btn = $('#dc-submit');
  function syncPrice() {
    var r = $('input[name="id"]:checked');
    if (!r) return;
    var p = r.getAttribute('data-price');
    if (priceEl) priceEl.textContent = p;
  }
  $$('input[name="id"]').forEach(function (r) { r.addEventListener('change', syncPrice); });
  syncPrice();

  // ---- 叶っていること：3つまで ----
  var goalWrap = $('.cards[data-max]');
  function syncGoals() {
    if (!goalWrap) return;
    var max = parseInt(goalWrap.getAttribute('data-max'), 10), boxes = $$('input.goal', goalWrap);
    var n = boxes.filter(function (b) { return b.checked; }).length;
    boxes.forEach(function (b) { b.disabled = !b.checked && n >= max; });
  }
  $$('input.goal').forEach(function (b) { b.addEventListener('change', syncGoals); });
  syncGoals();

  // ---- 一緒にいる：子どもを選んだら人数 ----
  var kids = $('#dc-kids');
  function syncKids() {
    var on = $$('input.who').some(function (b) { return b.checked && b.value === '子ども'; });
    if (kids) { kids.hidden = !on; $$('select', kids).forEach(function (s2) { s2.disabled = !on; }); }
  }
  $$('input.who').forEach(function (b) { b.addEventListener('change', syncKids); });
  syncKids();

  // ---- 家族の写真：入れた人は「一緒にいる」にも自動でチェック。子ども・孫は男の子／女の子を選ぶ ----
  var famRel = { 'パートナー（夫・妻）': 'パートナー', '子ども': '子ども' };
  function syncFamily() {
    var sex = { '男の子': 0, '女の子': 0 };
    $$('.famslot').forEach(function (sl) {
      var rel = $('.famrel', sl), sx = $('.famsex', sl), fi = $('input[type=file]', sl);
      if (!rel) return;
      var child = rel.value === '子ども' || rel.value === '孫';
      if (sx) { sx.hidden = !child; sx.disabled = !child; }
      if (!(fi && fi.files && fi.files.length)) return;
      var chip = $$('input.who').filter(function (b) { return b.value === (famRel[rel.value] || '家族（親・きょうだいなど）'); })[0];
      if (chip && !chip.checked) { chip.checked = true; chip.dispatchEvent(new Event('change', { bubbles: true })); }
      if (rel.value === '子ども' && sx && sx.value) sex[sx.value]++;
    });
    // 写真の子どもの人数より少なければ、上の人数を合わせる
    [['dc-boys', '男の子'], ['dc-girls', '女の子']].forEach(function (p) {
      var el = document.getElementById(p[0]); if (el && +el.value < sex[p[1]]) el.value = String(Math.min(3, sex[p[1]]));
    });
  }
  $$('.famslot select, .famslot input').forEach(function (f) { f.addEventListener('change', syncFamily); });
  syncFamily();

  // ---- 一緒にいる：仲間・チーム／お客さまを選んだら描き方を選ぶ ----
  var crew = $('#dc-crew');
  function syncCrew() {
    var on = $$('input.who').some(function (b) { return b.checked && (b.value === '仲間・チーム' || b.value === 'お客さま・ファン'); });
    if (crew) { crew.hidden = !on; $$('input', crew).forEach(function (f) { f.disabled = !on; }); }
  }
  $$('input.who').forEach(function (b) { b.addEventListener('change', syncCrew); });
  syncCrew();

  // ---- 一緒にいる：ペットを選んだら数・どんな子・写真 ----
  var pets = $('#dc-pets');
  function syncPets() {
    var on = $$('input.who').some(function (b) { return b.checked && b.value === 'ペット'; });
    if (pets) { pets.hidden = !on; $$('select, input', pets).forEach(function (f) { f.disabled = !on; }); }
  }
  $$('input.who').forEach(function (b) { b.addEventListener('change', syncPets); });
  syncPets();

  // ---- 目覚める場所：自分で書く ----
  var pf = $('#dc-place-free');
  function syncPlace() {
    var sel = $('input.place:checked');
    var on = sel && sel.value === '自分で書く';
    if (pf) { pf.hidden = !on; pf.disabled = !on; }
  }
  $$('input.place').forEach(function (r) { r.addEventListener('change', syncPlace); });
  syncPlace();

  // ---- 例文ボタン → ひとこと欄へ ----
  var dream = $('#dc-dream');
  $$('.exb:not([data-years]):not([data-months])').forEach(function (b) { b.addEventListener('click', function () {
    var t = document.getElementById(b.getAttribute('data-for') || 'dc-dream') || dream;
    if (t) { t.value = b.textContent; t.focus(); }
  }); });

  // ---- 未来の一日：書き出しボタン → 自由記入欄の最後に足す ----
  $$('.starter').forEach(function (b) { b.addEventListener('click', function () {
    var ta = $('#dc-day'); if (!ta) return;
    var add = b.getAttribute('data-text');
    ta.value = ta.value.replace(/\s+$/, '') + (ta.value.trim() ? '\n' : '') + add;
    ta.focus();
    var pos = add.indexOf('「」') >= 0 ? ta.value.length - add.length + add.indexOf('「」') + 1 : ta.value.length;  // 言葉の欄は「」の中にカーソル
    ta.setSelectionRange(pos, pos);
  }); });

  // ---- 未来フォーム：その日（カレンダー＋手入力。年は « » でひとつずつ進める） ----
  var cal = $('#dc-cal');
  if (cal) {
    var dText = $('#dc-date-text'), dVal = $('#dc-date'), dNote = $('#dc-date-note');
    var WD = '日月火水木金土';
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var minD = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
    var maxD = new Date(today.getFullYear() + 50, 11, 31);
    var startM = +(cal.getAttribute('data-start-months') || 36);
    var view = new Date(today.getFullYear(), today.getMonth() + startM, 1), sel = null;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function later(d) {
      var m = (d.getFullYear() - today.getFullYear()) * 12 + d.getMonth() - today.getMonth();
      return m < 12 ? '約' + Math.max(1, m) + 'か月後' : '約' + Math.round(m / 12) + '年後';
    }
    function label(d) { return d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日（' + WD[d.getDay()] + '）'; }
    function clampView() {
      if (view < new Date(minD.getFullYear(), minD.getMonth(), 1)) view = new Date(minD.getFullYear(), minD.getMonth(), 1);
      if (view > new Date(maxD.getFullYear(), 11, 1)) view = new Date(maxD.getFullYear(), 11, 1);
    }
    function pick(d, fromText) {
      sel = d; view = new Date(d.getFullYear(), d.getMonth(), 1);
      dVal.value = label(d) + '・' + later(d);
      if (!fromText) dText.value = d.getFullYear() + '/' + pad(d.getMonth() + 1) + '/' + pad(d.getDate());
      dNote.textContent = label(d) + '　' + later(d); dNote.classList.remove('bad');
      render(); dVal.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function render() {
      clampView();
      var y = view.getFullYear(), m = view.getMonth();
      var h = '<div class="cal-head">'
        + '<div class="cal-row"><button type="button" class="cal-nav" data-dy="-1" aria-label="前の年">«</button><b>' + y + '年</b><button type="button" class="cal-nav" data-dy="1" aria-label="次の年">»</button></div>'
        + '<div class="cal-row"><button type="button" class="cal-nav" data-dm="-1" aria-label="前の月">‹</button><b>' + (m + 1) + '月</b><button type="button" class="cal-nav" data-dm="1" aria-label="次の月">›</button></div>'
        + '</div><div class="cal-grid">';
      for (var i = 0; i < 7; i++) h += '<span class="cal-wd' + (i === 0 ? ' sun' : i === 6 ? ' sat' : '') + '">' + WD[i] + '</span>';
      var first = new Date(y, m, 1).getDay(), days = new Date(y, m + 1, 0).getDate();
      for (i = 0; i < first; i++) h += '<span></span>';
      for (var d = 1; d <= days; d++) {
        var dt = new Date(y, m, d), off = dt < minD || dt > maxD;
        var on = sel && dt.getTime() === sel.getTime();
        h += '<button type="button" class="cal-d' + (on ? ' on' : '') + (dt.getDay() === 0 ? ' sun' : dt.getDay() === 6 ? ' sat' : '') + '" data-d="' + d + '"' + (off ? ' disabled' : '') + '>' + d + '</button>';
      }
      cal.innerHTML = h + '</div>';
    }
    cal.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.hasAttribute('data-dy')) { view = new Date(view.getFullYear() + +b.getAttribute('data-dy'), view.getMonth(), 1); render(); }
      else if (b.hasAttribute('data-dm')) { view = new Date(view.getFullYear(), view.getMonth() + +b.getAttribute('data-dm'), 1); render(); }
      else if (b.hasAttribute('data-d')) pick(new Date(view.getFullYear(), view.getMonth(), +b.getAttribute('data-d')));
    });
    $$('[data-years]').forEach(function (b) { b.addEventListener('click', function () {
      view = new Date(today.getFullYear() + +b.getAttribute('data-years'), today.getMonth(), 1); render();
    }); });
    $$('[data-months]').forEach(function (b) { b.addEventListener('click', function () {
      view = new Date(today.getFullYear(), today.getMonth() + +b.getAttribute('data-months'), 1); render();
    }); });
    // 手入力：2029/6/12・2029-06-12・2029年6月12日・20290612 など。全角数字もOK
    dText.addEventListener('input', function () {
      var t = dText.value.replace(/[０-９]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xFEE0); });
      var mt = t.match(/^\s*(\d{4})\D+(\d{1,2})\D+(\d{1,2})/) || t.match(/^\s*(\d{4})(\d{2})(\d{2})\s*$/);
      if (!mt) { dVal.value = ''; sel = null; dNote.textContent = t.trim() ? '年/月/日 の順で入れてください（例：2029/06/12）' : ''; dNote.classList.toggle('bad', !!t.trim()); render(); return; }
      var d = new Date(+mt[1], +mt[2] - 1, +mt[3]);
      if (d.getMonth() !== +mt[2] - 1 || d.getDate() !== +mt[3]) { dVal.value = ''; dNote.textContent = 'その日付はありません'; dNote.classList.add('bad'); return; }
      if (d < minD) { dVal.value = ''; dNote.textContent = '明日より先の日付を入れてください'; dNote.classList.add('bad'); return; }
      if (d > maxD) { dVal.value = ''; dNote.textContent = maxD.getFullYear() + '年までの日付を入れてください'; dNote.classList.add('bad'); return; }
      pick(d, true);
    });
    render();
  }

  // ---- 参考写真：枠を増やす ----
  var addR = $('#dc-add-ref');
  if (addR) addR.addEventListener('click', function () {
    var h = $$('.refslot[hidden]')[0];
    if (h) h.hidden = false;
    if (!$$('.refslot[hidden]').length) addR.hidden = true;
  });

  // ---- 写真のプレビュー（ページ内だけ） ----
  var photo = $('#dc-photo'), prevImg = $('#dc-photo-preview'), prevCap = $('#dc-photo-cap');
  if (photo) photo.addEventListener('change', function () { if (photo.files && photo.files.length) track('photo'); });
  if ($('#dc-consent')) $('#dc-consent').addEventListener('change', function () { if (this.checked) track('consent'); });
  if (photo && prevImg) photo.addEventListener('change', function () {
    var f = photo.files && photo.files[0]; if (!f) return;
    var rd = new FileReader();
    rd.onload = function () { prevImg.src = rd.result; if (prevCap) prevCap.textContent = 'あなたの写真'; };
    rd.readAsDataURL(f);
  });

  // ---- その場でキャラ作成（中継サーバー経由） ----
  var gen = $('#dc-gen');
  if (gen && photo) {
    var api = gen.getAttribute('data-api').replace(/\/$/, '');
    var gbtn = $('#dc-gen-btn'), gact = $('#dc-gen-act'), gok = $('#dc-gen-ok'), gretry = $('#dc-gen-retry');
    var gimg = $('#dc-gen-img'), gwait = $('#dc-gen-wait'), gmsg = $('#dc-gen-msg'), gcap = $('#dc-gen-cap'), gurl = $('#dc-gen-url'), gleft = $('#dc-gen-left');
    var steps = ['写真から顔の特徴を読み取っています…', '髪型や服を確認しています…', '漫画のタッチで描いています…', '仕上げています…（30秒〜1分ほどかかります）'];
    var lastUrl = '';
    function canGen() { return photo.files && photo.files.length && $('#dc-consent') && $('#dc-consent').checked; }
    function syncBtn() { gbtn.disabled = !canGen(); }
    photo.addEventListener('change', function () { syncBtn(); unpick(); gact.hidden = true; if (lastUrl) { gbtn.hidden = false; gcap.textContent = '新しい写真で「AIでキャラクターにする」を押してください'; } });
    $('#dc-consent').addEventListener('change', syncBtn);
    syncBtn();
    function run() {
      if (!canGen()) return;
      track('gen_click');
      gbtn.disabled = true; unpick(); gact.hidden = true; gwait.hidden = false;
      var i = 0; gmsg.textContent = steps[0];
      var iv = setInterval(function () { i = Math.min(i + 1, steps.length - 1); gmsg.textContent = steps[i]; }, 6000);
      var fd = new FormData();
      fd.append('photo', photo.files[0]);
      var note = $('input[name="properties[キャラの変更]"]'); if (note && note.value) fd.append('note', note.value);
      fetch(api + '/generate', { method: 'POST', body: fd }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, status: r.status, d: d }; }); })
        .then(function (res) {
          clearInterval(iv); gwait.hidden = true;
          if (typeof res.d.left === 'number') gleft.textContent = res.d.left > 0 ? '（今日あと' + res.d.left + '回）' : '（今日の回数を使い切りました）';
          if (!res.ok) {
            gmsg.textContent = ''; gcap.textContent = res.d.error || 'キャラクターを作れませんでした'; gbtn.disabled = !canGen() || res.d.left === 0;
            if (res.d.left === 0 && !lastUrl) gen.setAttribute('data-down', '1');
            if (res.status === 503 || (res.status === 429 && res.d.left !== 0)) gen.setAttribute('data-down', '1');
            return;
          }
          track('gen_ok'); lastUrl = res.d.url; gimg.src = res.d.url; gcap.textContent = 'あなたのキャラクター';
          gact.hidden = false; gretry.disabled = res.d.left === 0; gretry.textContent = res.d.left > 0 ? '作り直す（あと' + res.d.left + '回）' : '作り直しはここまで';
          gbtn.hidden = true;
        })
        .catch(function () { clearInterval(iv); gwait.hidden = true; gcap.textContent = '通信できませんでした。少し時間をおいてお試しください。'; gbtn.disabled = !canGen(); gen.setAttribute('data-down', '1'); });
    }
    gbtn.addEventListener('click', run);
    gretry.addEventListener('click', run);
    // 決定：チェックつきの表示に切り替える。チェックを外せば、決定を取り消して選び直せる
    var pickWrap = $('#dc-gen-pick-wrap'), pick = $('#dc-gen-pick');
    function choose() { track('decide'); gurl.value = lastUrl; gurl.disabled = false; $('.genfig').classList.add('chosen'); gcap.textContent = 'このキャラクターで決定'; gok.hidden = true; gact.hidden = false; pickWrap.hidden = false; pick.checked = true; }
    function unpick() { gurl.value = ''; gurl.disabled = true; $('.genfig').classList.remove('chosen'); gok.hidden = false; if (pickWrap) pickWrap.hidden = true; }
    gok.addEventListener('click', choose);
    // 別の写真で作り直す：写真の選び直しを開く
    $('#dc-gen-other').addEventListener('click', function () { photo.click(); });
    pick.addEventListener('change', function () {
      if (pick.checked) return choose();
      unpick(); gcap.textContent = 'あなたのキャラクター'; gact.hidden = false;
    });
  }

  // ---- 未来フォーム：家族の写真も、その場でキャラクターにして確かめる（任意） ----
  var famConsent = $('#dc-fam-consent');
  function syncFamBtns() {
    $$('.famslot').forEach(function (sl) {
      var fi = $('input[type=file]', sl), b = $('.famgenbtn', sl);
      if (b) b.disabled = !(fi && fi.files && fi.files.length && famConsent && famConsent.checked);
    });
  }
  if (famConsent) famConsent.addEventListener('change', syncFamBtns);
  $$('.famslot').forEach(function (sl) {
    var fi = $('input[type=file]', sl), b = $('.famgenbtn', sl), res = $('.famgenres', sl), im = $('.famgenimg', sl), msg = $('.famgenmsg', sl), url = $('.famgenurl', sl);
    if (!fi || !b) return;
    fi.addEventListener('change', function () { url.value = ''; url.disabled = true; res.hidden = true; b.textContent = 'この写真をAIでキャラクターにする'; syncFamBtns(); });
    b.addEventListener('click', function () {
      if (!(fi.files && fi.files.length)) return;
      if (!famConsent || !famConsent.checked) { msg.textContent = '上の確認にチェックを入れてください。'; res.hidden = false; return; }
      b.disabled = true; b.textContent = 'キャラクターにしています…（1分ほど）';
      var fd = new FormData(); fd.append('photo', fi.files[0]);
      fetch(API + '/generate', { method: 'POST', body: fd })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (r) {
          res.hidden = false;
          if (!r.ok || !r.d.url) { im.hidden = true; msg.textContent = (r.d && r.d.error) || 'キャラクターを作れませんでした。写真だけでも大丈夫です。こちらで作ります。'; b.textContent = 'もう一度作る'; b.disabled = false; return; }
          im.hidden = false; im.src = r.d.url; msg.textContent = 'このキャラクターで描きます'; url.value = r.d.url; url.disabled = false;
          b.textContent = '作り直す'; b.disabled = false;
        })
        .catch(function () { res.hidden = false; msg.textContent = '通信できませんでした。写真だけでも大丈夫です。こちらで作ります。'; b.textContent = 'もう一度作る'; b.disabled = false; });
    });
  });
  syncFamBtns();

  // ---- 送信前チェック（写真・同意・キャラクター決定） ----
  var form = $('#dc-form'), err = $('#dc-error');
  if (form) form.addEventListener('submit', function (e) {
    var msg = '';
    if (photo && !(photo.files && photo.files.length)) msg = 'キャラクターを作るための写真を1枚えらんでください。';
    else if ($('#dc-consent') && !$('#dc-consent').checked) msg = '写真の取り扱いへの同意にチェックを入れてください。';
    else if (gen && $('#dc-gen-url').disabled && gen.getAttribute('data-down') !== '1')
      msg = '「AIでキャラクターにする」でキャラクターを作り、「このキャラクターで決定」を押してください。';
    // 非表示の人・参考写真の欄は送らない
    $$('.refslot[hidden] input, .refslot[hidden] select').forEach(function (f) { f.disabled = true; });
    if (msg) { e.preventDefault(); if (err) { err.textContent = msg; err.hidden = false; err.scrollIntoView({ block: 'center' }); } return; }
    // 前に入れたままの商品がカートに残っていると一緒に買われてしまうので、カートを空にしてから入れる
    e.preventDefault();
    if (btn) { btn.disabled = true; btn.textContent = '準備しています…'; }
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .catch(function () {})
      .then(function () { track('checkout'); form.submit(); });
  });
  // ---- 未来フォーム：家族写真の枠を増やす ----
  var addF = $('#dc-add-fam');
  if (addF) addF.addEventListener('click', function () {
    var h = $$('.famslot[hidden]')[0];
    if (h) h.hidden = false;
    if (!$$('.famslot[hidden]').length) addF.hidden = true;
  });

  // 入力・選択したら「足りない」の赤枠を消す
  root.addEventListener('input', function (e) { var b = e.target.closest && e.target.closest('.missing'); if (b) b.classList.remove('missing'); });
  root.addEventListener('change', function (e) { var b = e.target.closest && e.target.closest('.missing'); if (b) b.classList.remove('missing'); });

  // ---- 注文後の未来フォーム：送信 ----
  var mf = $('#dc-mirai');
  if (mf) {
    var q = new URLSearchParams(location.search), ord = $('#dc-order');
    if (q.get('order') && ord) ord.value = q.get('order').replace(/[^0-9]/g, '');
    // LITE（漫画1ページ＝いちばんうれしい瞬間の1シーン）には、朝と夜の質問を出さない（注文確認メールのリンクに plan がつく）
    if ((q.get('plan') || '').toUpperCase() === 'LITE') $$('[data-multi]').forEach(function (b) { b.hidden = true; $$('textarea, input', b).forEach(function (f) { f.disabled = true; }); });
    var send = $('#dc-send'), merr = $('#dc-error');
    function fail(m) {
      $$('.famslot:not([hidden]) select, .famslot:not([hidden]) input').forEach(function (f) { f.disabled = false; });  // 送り直せるように戻す
      merr.textContent = m; merr.hidden = false; merr.scrollIntoView({ block: 'center' }); send.disabled = false; send.textContent = 'この未来で描いてもらう';
    }
    // 目標版フォーム：「目標」か「夢」かで、出す欄を切りかえる
    var kinds = $$('input[name="描きたいもの"]', mf);
    function syncKind() {
      var dream = kinds.some(function (r) { return r.checked && r.value === '夢'; });
      $$('[data-dream]', mf).forEach(function (el) { el.hidden = !dream; });
      $$('[data-goalonly]', mf).forEach(function (el) { el.hidden = dream; });
      var dr = $('#dc-dream', mf);
      if (dr) { dr.setAttribute('data-label', dream ? '叶えたい夢' : 'あなたの目標'); dr.placeholder = dream ? '例：海の近くで、自分のパン屋を開いている' : '例：3か月で−3kg。着たかったワンピースを着る'; }
      var mo = $('#dc-moment', mf);
      if (mo) mo.placeholder = dream ? '例：私は今、開店前から並んでくれたお客さまに、焼きたてのパンを手わたしている。' : '例：私は今、着たかったワンピースを着て、友だちと海の見えるカフェで笑っている。';
    }
    kinds.forEach(function (r) { r.addEventListener('change', syncKind); });
    if (kinds.length) syncKind();
    mf.addEventListener('submit', function (e) {
      e.preventDefault(); merr.hidden = true;
      var o = ($('#dc-order').value || '').replace(/[^0-9]/g, ''), em = ($('#dc-email').value || '').trim();
      // 必須の項目（漫画を描くのに欠かせないもの）。足りなければ、その欄へ飛んで知らせる
      $$('.missing').forEach(function (x) { x.classList.remove('missing'); });
      // 空いている必須項目を全部集めて、全部に枠をつけ、一番上へ移動して、まとめて知らせる
      var val = function (id) { var e = $('#' + id); return e ? e.value.trim() : ''; };
      var miss = [];
      function need(ok, el, label) { if (!ok) miss.push({ el: el, label: label }); }
      need(o, $('#dc-order'), '注文番号');
      need(/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em), $('#dc-email'), 'ご注文時のメールアドレス');
      // あなたのキャラクター：決定済み（生成サーバーが止まっているときは、写真を選んであればOK）
      if ($('#dc-step-char')) {
        var charOk = !$('#dc-gen-url').disabled || (gen && gen.getAttribute('data-down') === '1' && photo && photo.files && photo.files.length);
        need(charOk, $('#dc-step-char'), 'あなたのキャラクター（写真を選んで「このキャラクターで決定」）');
      }
      var shown = function (el) { return el && !el.closest('[hidden]') && !el.closest('[data-soft]'); };  // 隠れている欄・任意のかたまり（data-soft）は必須にしない  // 隠れている欄（目標版の「夢」だけの欄など）は聞かない
      if (shown($('#dc-date-text'))) need(val('dc-date'), $('#dc-date'), 'その日の日付');
      var age = parseInt(val('dc-age').replace(/[０-９]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xFEE0); }), 10);
      if (shown($('#dc-age'))) need(age >= 1 && age <= 120, $('#dc-age'), 'その日の年齢');
      need(val('dc-dream'), $('#dc-dream'), ($('#dc-dream') && $('#dc-dream').getAttribute('data-label')) || 'いちばん叶っていること');
      need(val('dc-moment'), $('#dc-moment'), 'いちばんうれしい瞬間');
      need(val('dc-place'), $('#dc-place'), 'その瞬間の場所');
      if (shown($('#dc-who'))) need($$('input.who').some(function (b) { return b.checked; }), $('#dc-who'), '一緒にいる人');
      need(!$$('input.who').some(function (b) { return b.checked && b.value === 'ペット'; }) || val('dc-petkind'), $('#dc-petkind'), 'ペットがどんな子か');
      need(!$$('input.who').some(function (b) { return b.checked && b.value === '子ども'; }) || (+val('dc-boys') + +val('dc-girls')) > 0, $('#dc-kids'), '子どもの人数');
      need(!$$('.famslot').some(function (sl) { var fi = $('input[type=file]', sl), sx = $('.famsex', sl); return fi && fi.files && fi.files.length && sx && !sx.hidden && !sx.value; }), $('#dc-family'), '写真の子どもが男の子か女の子か');
      need(val('dc-call'), $('#dc-call'), '呼ばれ方');
      need(val('dc-thanks'), $('#dc-thanks'), '感謝している人');
      if (miss.length) {
        miss.forEach(function (m) { var box = m.el && (m.el.closest('.opt') || m.el.closest('label') || m.el); if (box) box.classList.add('missing'); });
        var first = miss[0].el && (miss[0].el.closest('.opt') || miss[0].el.closest('label') || miss[0].el);
        if (first) first.scrollIntoView({ block: 'center', behavior: 'smooth' });
        merr.textContent = 'あと少し！ まだ入っていない項目が ' + miss.length + 'つあります（赤い枠のところ）：' + miss.map(function (m) { return m.label; }).join('、');
        merr.hidden = false; send.disabled = false; send.textContent = 'この未来で描いてもらう';
        var toast = $('#dc-toast');
        if (!toast) { toast = document.createElement('div'); toast.id = 'dc-toast'; toast.className = 'toast'; root.appendChild(toast); }
        toast.textContent = merr.textContent; toast.hidden = false;
        clearTimeout(toast._t); toast._t = setTimeout(function () { toast.hidden = true; }, 6000);
        return;
      }
      if ($('#dc-toast')) $('#dc-toast').hidden = true;
      var famPhotos = $$('.famslot input[type=file]').filter(function (f) { return f.files && f.files.length; });
      if (famPhotos.length && !$('#dc-fam-consent').checked) { $('#dc-family').open = true; return fail('家族の写真を送るときは、了承を得ていることの確認にチェックを入れてください。'); }
      $$('.refslot[hidden] input, .refslot[hidden] select, .famslot[hidden] input, .famslot[hidden] select').forEach(function (f) { f.disabled = true; });
      $$('.famslot').forEach(function (sl) {  // 写真のない枠の続柄・呼び方は送らない
        var fi = $('input[type=file]', sl); if (!(fi.files && fi.files.length)) $$('select, input', sl).forEach(function (f) { f.disabled = true; });
      });
      if ($('#dc-age') && $('#dc-age').value.trim()) $('#dc-age').value = String(parseInt($('#dc-age').value.replace(/[０-９]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xFEE0); }), 10));
      var fd = new FormData(mf);
      $$('[data-dream][hidden] [name]', mf).forEach(function (f) { fd.delete(f.name); });  // 目標を選んだ人は、夢だけの欄を送らない
      fd.set('order', o);
      $$('input[type=file]', mf).forEach(function (f) { if (!f.files || !f.files.length) fd.delete(f.name); });
      send.disabled = true; send.textContent = '送っています…';
      fetch(mf.getAttribute('data-api').replace(/\/$/, '') + '/interview', { method: 'POST', body: fd })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) return fail(res.d.error || '送れませんでした。少し時間をおいてお試しください。');
          track('mirai_sent'); mf.hidden = true; if ($('#dc-intro')) $('#dc-intro').hidden = true; $('#dc-done').hidden = false; window.scrollTo(0, 0);
        })
        .catch(function () { fail('通信できませんでした。少し時間をおいてお試しください。'); });
    });
  }
})();
